export default "__VITE_ASSET__f81745bc__"